import { Reducer } from "redux";

import { MasterSendCommunicationAuthTypeResponse } from "../models/api/Patient";
import { MasterSendCommunicationAuthTypeDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterSendCommunicationAuthTypeActionDispatchTypes } from "../constants/Master";

const initialState: MasterSendCommunicationAuthTypeResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterSendCommunicationAuthTypeReducer: Reducer<
  MasterSendCommunicationAuthTypeResponse,
  MasterSendCommunicationAuthTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterSendCommunicationAuthTypeActionDispatchTypes.MASTER_SEND_COMMUNICATION_AUTH_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterSendCommunicationAuthTypeActionDispatchTypes.MASTER_SEND_COMMUNICATION_AUTH_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterSendCommunicationAuthTypeActionDispatchTypes.MASTER_SEND_COMMUNICATION_AUTH_TYPE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterSendCommunicationAuthTypeReducer;
